import { render, staticRenderFns } from "./SocialMediaSignInInProgress.vue?vue&type=template&id=2b539046&scoped=true&"
import script from "./SocialMediaSignInInProgress.vue?vue&type=script&lang=js&"
export * from "./SocialMediaSignInInProgress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b539046",
  null
  
)

export default component.exports